import { type FC } from 'react';
import { Outlet } from 'react-router-dom';

import { useGetLotteryInfoQuery } from '@/api/queries/lottery/lottery';
import { AppRoute } from '@/common/app/routes';
import { useMatchPath } from '@/common/hooks/match-path';
import { LotterBottomMenu } from '@/components/Lottery/LotteryBottomMenu/LotteryBottomMenu';

import { TicketDrawInfo } from './TicketDrawInfo/TicketDrawInfo';

const LotteryLayout: FC = () => {
  const isPageWithoutBottomMenu = useMatchPath([AppRoute.LOTTERY + '/faq']);
  useGetLotteryInfoQuery();

  return (
    <main className="w-full h-full flex flex-col">
      <TicketDrawInfo />
      <Outlet />
      {!isPageWithoutBottomMenu && <LotterBottomMenu />}
    </main>
  );
};

export { LotteryLayout };
